/**
 * Return a string without any accented caracter.
 *
 * @example accentFold('olakëase') -> olakease
 *
 * For information, posible list of
 * /[àáâãäå]/ -> a
 * /[ÀÁÂÃÄÅ]/ -> A
 * /[ç]/ -> c
 * /[Ç]/ -> C
 * /[èéêë]/ -> e
 * /[ÈÉÊË]/ -> E
 * /[ìíîï]/ -> i
 * /[ÌÍÎÏ]/ -> I
 * /ñ/ -> n
 * /Ñ/ -> N
 * /[òóôõö]/ -> o
 * /[ÒÓÔÕÖ]/ -> O
 * /[ùúûü]/ -> u
 * /[ÙÚÛÜ]/ -> U
 * /[ýÿ]/ -> y
 * /[ÝŸ]/ -> Y
 * /[æ]/ -> ae
 * /[œ]/ -> oe
 *
 * @param {string} str text to replace
 * @returns {string}
 */
export function accentFold(str = '') {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
